import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { ErrorOutlineIcon } from 'shared/icons';

const NoPlanDialogView = ({ message }: { message: string }) => {
   return (
      <Box width="fit-content">
         <Flex justify="center">
            <Text color="red">
               <ErrorOutlineIcon width={80} height={80} />
            </Text>
         </Flex>

         <Flex justify="center" direction="column" align="center" mt="5" mb="6">
            <Dialog.Title size="7" align="center">
               {message}
            </Dialog.Title>
         </Flex>

         <Flex justify="center" gap="3">
            <Dialog.Close>
               <Button color="gray" size="3">
                  Закрити
               </Button>
            </Dialog.Close>
         </Flex>
      </Box>
   );
};

export const NoPlanDialog = observer(NoPlanDialogView);
